import { definePresentationResponse } from "../presenter"

export interface ConfirmationRequest {
  /** What the user is asked, for example "Delete this page?". */
  readonly message: string
  readonly title?: string
  /** Label of the button that confirms. Defaults to a localized "OK". */
  readonly confirmLabel?: string
  /** Label of the button that declines. Defaults to a localized "Cancel". */
  readonly cancelLabel?: string
  /** Marks the action as destructive: the dialog shows a warning caption and focuses the cancel button first. */
  readonly destructive?: boolean
}

/** Resolves to true when the user confirms, and to false when they decline or dismiss the dialog. */
export const confirmationResponse = definePresentationResponse<ConfirmationRequest, boolean>({
  type: "Confirmation",
})
